
import { Action } from '@ngrx/store';



export enum UserActionTypes {
  USER = 'USER',
  USER_SUCCESS  = 'USER_SUCCESS',
  USER_FAILURE  = 'USER_FAILURE',
  USER_EMAIL_VERIFIED = 'USER_EMAIL_VERIFIED',
  EMAIL_SUCCESS = 'EMAIL_SUCCESS',
  DEFAULT_USER = 'DEFAULT_USER',
  MATERIAL_PROVIDER = 'MATERIAL_PROVIDER',
  MATERIAL_PROVIDER_SUCCESS = 'MATERIAL_PROVIDER_SUCCESS',
  MATERIAL_PROVIDER_FAILURE = 'MATERIAL_PROVIDER_FAILURE'
}

export class User implements Action {
  readonly type = UserActionTypes.USER;
}
export class DefaultUser implements Action {
  readonly type = UserActionTypes.DEFAULT_USER;
  constructor(public payload: any) {}
}
export class UserSuccess implements Action {
  readonly type = UserActionTypes.USER_SUCCESS;
  constructor(public payload: any) {}
}
export class Material implements Action {
  readonly type = UserActionTypes.MATERIAL_PROVIDER;
  constructor(public payload: any) {}  
}
export class UserFailure implements Action {
  readonly type = UserActionTypes.USER_FAILURE;
  constructor(public payload: any) {}
}
export class UserEmailVerified implements Action {
  readonly type = UserActionTypes.USER_EMAIL_VERIFIED;
  
}
export class UserEmailSuccess implements Action {
  readonly type = UserActionTypes.EMAIL_SUCCESS;
  constructor(public payload: any) {}
}
export class MaterialSuccess implements Action {
  readonly type = UserActionTypes.MATERIAL_PROVIDER_SUCCESS;
  constructor(public payload: any) {}
}
export class MaterialFailure implements Action {
  readonly type = UserActionTypes.MATERIAL_PROVIDER_FAILURE;
  constructor(public payload: any) {}
}
export type All =
  | User
  | UserSuccess
  | UserEmailVerified
  | UserEmailSuccess
  | Material
  | MaterialSuccess
  | MaterialFailure
  | UserFailure;